import { createActionGroup, emptyProps } from '@ngrx/store';

export const UserPreferencesActions = createActionGroup({
  source: 'User Preferences',
  events: {
    'Toggle Theme Preference': emptyProps(),
  }
});
